import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ApplicationAttributeState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';


export const state: ApplicationAttributeState = {
  applicationAttributes: [],
  applicationAttribute: undefined,
  attributeTypeList: ['Date','Number','String']
};

export const applicationAttribute: Module<ApplicationAttributeState, RootState> = {
  state,
  getters,
  actions,
  mutations
};